import { browser } from '$app/environment';
import { ApolloLink } from '@apollo/client/link/core/index.js';
import { writable } from 'svelte/store';

type PerformanceData = {
  requests: Request[];
  totalRequestsForSession: number;
};

type Request = {
  elapsed: number;
  operationName: string;
};

export const performanceStore = writable<PerformanceData>({ requests: [], totalRequestsForSession: 0 });

// Extract performance information returned from the GraphQL API
export const performanceLink = () =>
  new ApolloLink((operation, forward) => {
    if (!browser) {
      return forward(operation);
    }
    // Continue the link chain and handle the final response
    return forward(operation).map(data => {
      if (data.extensions?.performance) {
        const { elapsed, operation_name } = data.extensions.performance;
        performanceStore.update(value => ({
          totalRequestsForSession: value.totalRequestsForSession + 1,
          requests: [
            {
              elapsed,
              operationName: operation_name
            },
            ...value.requests.slice(0, 9)
          ]
        }));
      }
      return data;
    });
  });
